export default "__VITE_ASSET__BhwpBEA4__"